import React, { useState, useEffect,useRef } from "react";
import ReactPaginate from "react-paginate";
import axios from 'axios';
import { getUserId,aPIURL,auTHURL,getLoginName,websiteUrl } from '../../utils/common';
import Modal from '../Modal';
import ModalSale from '../ModalSale';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useReactToPrint } from 'react-to-print';
//import { useDownloadExcel } from "react-export-table-to-excel";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import Locations from './CVLocations';
import Ctus from '../ShowMap';
import HistoryonMap from "./HistoryonMap";
import HistoryPlayback from "./HistoryPlayback"
//import LoadingSpinner from "../LoadingSpinner";

const CLVehicleList = () => {

  const fileType ="xlsx";
  const [isLoading, setIsLoading] = useState(false);
  const tableRef = useRef(null);
  const [status, setStatus]  = useState({});
  const API_URL=aPIURL();
  const [userId, setUserId]  = useState({});
  const [userName, setUserName]  = useState({});
  const [inputs, setInputs] = useState({});
  const [inputsEdit, setInputsEdit] = useState({});
  const [post, setPost] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [vCategoryData, setVCategoryData]= useState([]);
  const [vCountryData, setVCountryData]= useState([]);
  const [vStateData, setVStateData]= useState([]);
  const [vIEMIData, setVIEMIData]= useState([]);
  const [vDriverData, setVDriverData]= useState([]);

  const [number, setNumber] = useState(1); // No of pages
  const [postPerPage] = useState(10);
  const [showAddVehicle, setShowAddVehicle]= useState(false);
  const [viewVehicle, setViewVehicle]= useState(false);
  const [showEditVehicle, setShowEditVehicle]= useState(false);
  const [showViewLiveVehicle, setShowViewLiveVehicle]= useState(false);
  const [vCategoryID, setVCategoryID]= useState(0);
  const [vCountryID, setVCountryID]= useState(0);
  const [vStateID, setVStateID]= useState(0);
  //const [vCountryName, setVCountryName]= useState();
  const [sVehicleNo , setSVehicleNo]= useState();                    
  const [sPlateNo , setSPlateNo]= useState();                              
  const [sVehicleType, setSVehicleType]= useState();                             
  const [sVIN, setSVIN]= useState();   
  const [sMake , setSMake]= useState();                        
  const [sModel  , setSModel]= useState();                          
  const [sYear  , setSYear]= useState();                          
  const [sEngineNo, setSEngineNo]= useState();                           
  const [sIMEINo, setSIMEINo]= useState();  
  const [sFASTag, setSFASTag]= useState(); 
  const [sMileage, setSMileage] = useState("0");
  const [sCountry, setSCountry]= useState();  
  const [sState, setSState]= useState();   

  const [sDriverName, setSDriverName]= useState(); 
  const [sContactNumber, setSContactNumber]= useState(); 
  const [sAddress, setSAddress]= useState();     
  const [veCategoryID, setVeCategoryID]= useState(0);
  const [veCountryID, setVeCountryID]= useState(0);
  const [veStateID, setVeStateID]= useState(0);
  const [vIEMINumber, setVIEMINumber]=useState(0);
  const [veIEMINumber, setVeIEMINumber]=useState(0);

  const [vDriverID, setVDriverID]=useState(0);
  const [vEDriverID, setVEDriverID]=useState(0);
  const [order, setOrder] = useState("ASC");
  const [statusId, setStatusId]= useState(0);
  let SelectIEMIEdit='';

  const [sVehicle,setSVehicle]=useState();
  const [ssmodel,setSSModel]=useState();
  const [sdriver,setSdriver]=useState();
  const [filteredLocdata,setFilteredLocdata]  =useState([]);
  const [showLocation,setShowLocation ]  = useState(false);
  const [dID, setDID]  = useState('0');
  const rc =0;
  let [strLiveUrl,setStrLiveUrl]=  useState("");
  const [imeiNo,setImeiNo]= useState(0);
  //For history on map serach
    const [showHistoryDetails,setShowHistoryDetails]= useState(false);
    const [showHistoryPlayback,setShowHistoryPlayback]= useState(false);
    const [himei,setHimei]=useState();
    const [hfromdt,setHfromdate]=useState();
    const [htodate,setHtodate]=useState();
    const historyonmapinfo={IMEI:himei,fromDate:hfromdt,toDate:htodate}  
    const [historyData, setHistoryData] = useState([]);
    const [sOdometerReading, setSOdometerReading]= useState("0"); 
    const [sTankCapacity, setSTankCapacity]= useState(0);
    var fday = new Date();
    var fdd = fday.getDate();
    var fmm = fday.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
    var fyyyy = fday.getFullYear();
    if (fdd < 10){fdd = '0' + fdd}
    if (fmm < 10){fmm = '0' + fmm}
    fday = fyyyy + '-' + fmm + '-' + fdd;
      
    const [frFilterDate, setFrFilterDate]= useState(fday); 
    const [toFilterDate, setToFilterDate]= useState(fday); 
    const [vehicleNo,setVehicleNo]=useState('0');
    const [isShowMap, setIShowMap] = useState(false);


useEffect(() => 
{
   FillGrid(0);
}, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);


 const FillGrid=(Type_ID)=>
 {
  setIsLoading(true);
  const user_id = getUserId(); 
  setUserId(user_id);
  const User_Name=getLoginName();
  setUserName(User_Name);

  const curls=API_URL+`VehicleList/?AccountID=${user_id}&TypeID=${Type_ID}`;
  setPost([]);
  //alert(curls);
  axios.get(curls).then(response => 
    {                            
      setPost(response.data.data)
      setIsLoading(false); 
      console.log("-------------------Vehicle-----------------------");
      console.log(response.data.data); 
   }).catch(function(error)
   {
    setIsLoading(false);
    console.log(error.message);
  });      
 }
//Filter start

const FilterGrid=()=>
  {
    const Account_ID = getUserId(); 
    const searchparams = JSON.stringify({
      "accountid": Account_ID,
      "VehicleNumber":sVehicle,
      "VehicleModel":ssmodel,
      "DriverName": sdriver,
      "OrderBy": ""
    });

    //alert(searchparams);
    //alert(API_URL+'GpsSearchVehicleAdvance/');
    
    setPost([]);
    axios.post(API_URL+'GpsSearchVehicleAdvance/', searchparams, {  
      "headers":{"content-type": "application/json",},})
   .then(function (response) 
   {         
         setPost(response.data.data)      
        console.log(response.data.data);
   })
   .catch(function (error) 
   {
         toast.info("No data found !");
   });
  }
const ResetTripList=()=>
{
      setSVehicle("");
      setSSModel("");
      setSdriver("");
      FillGrid(0);
}

const VchangeHandler=(e)=>
{
    setSVehicle(e.target.value)
}
const MchangeHandler=(e)=>
{
      setSSModel(e.target.value)
}
const DchangeHandler=(e)=>
{
        setSdriver(e.target.value)
}
//Filterb End
const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);
};

const sorting=(col)=>
{

    try
    {
      if(order==="ASC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("DSC");
      }
      if(order==="DSC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("ASC");
      }
    }
    catch(error) 
    {
      console.log(error.message);
    }  
            
}
const exportStatus = e => {
    
    const value = e.target.value; 
    setStatusId(e.target.value);
    FillGrid(value);
}
const exportToCSV=()=>
{
      const newPost = post.map(({ address,contactNumber,countryId,countryName,deviceID,driverID,expiryDate,fasTag,imgPath,regYear,stateID,stateName,vehicleID,vehicleTypeID,vin, ...rest }) => rest);
       const ws= XLSX.utils.json_to_sheet(newPost);        
       var wscols = [
          {wch:5} ,
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},         
          {wch:20},
          {wch:20},         
          {wch:20}
      ];
   
      var wsrows = [
         {hpx: 30}
      ];
      
      ws['!cols'] = wscols;
      ws['!rows']=wsrows;
           
      let Heading = [['S.No.','IMEI Number','Vehicle Number','Engine Number','Make','Vehicle Model','Driver Name','Vehicle Type','Plate Number','Status']];
      const wb={Sheets:{Vehicle:ws},SheetNames:["Vehicle"]};
      XLSX.utils.sheet_add_aoa(ws, Heading);     
      const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
      const data= new Blob([excelBuffer],{type:fileType});
      FileSaver.saveAs(data,"AvtVehicleReport"+".xlsx");
     
  
}
const exportDownload = e => 
{  
  
  const value = e.target.value; 
  //alert(value)

if(value=="Excel")
{
    exportToCSV();    
    //onDownload();
}
if(value=="PDF")
{
        handlePrint(null, () => tableRef.current);
}
}
/*const { onDownload } = useDownloadExcel({
  currentTableRef: tableRef.current,
  filename: "Vehicle Details",
  sheet: "Vehicles"
}); */
const handlePrint = useReactToPrint({
  documentTitle: "Vehicle Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});

const showAddVehicleDetails=()=>
{
    setShowAddVehicle(true);   
    const catUrl=API_URL+"VehicleType/2";
    //alert(catUrl);
    axios.get(catUrl).then(response => {
        setVCategoryData(response.data.data);
    }).catch(function(error) 
    {
      console.log(error.message);
    });  
    
    //alert(API_URL+'countries');
    axios.post(API_URL+'countries').then(response => {
           setVCountryData(response.data.data);        
        }).catch(function(error) 
        {
          console.log(error.message);
        }); ;
        
    //alert(API_URL+'states?Country_ID=1');    
    axios.post(API_URL+'states?Country_ID=1').then(response => {
           setVStateData(response.data.data);  
        }).catch(function(error) 
        {
          console.log(error.message);
        }); ;

        const AIEMIUrl=API_URL+`ImeipendingList/{id}?StatusID=1&AccountID=${userId}`;
        //alert(AIEMIUrl);
        setVIEMIData([]);
      axios.get(AIEMIUrl).then(response => 
      {

        if(response.data.validStatus)
        {
            setVIEMIData(response.data.data);         
        }
      }).catch(function(error) 
      {
        console.log(error.message);
      });  
     //Driver List
     const ADriveUrl=API_URL+`PendingDriverList?StatusID=1&AccountID=${userId}`;
     //alert(ADriveUrl);
     setVDriverData([]);
      axios.get(ADriveUrl).then(response => 
      {

        if(response.data.validStatus)
        {
           setVDriverData(response.data.data);  
       
        }
      }).catch(function(error) 
      {
        console.log(error.message);
      });  
}  

const closeVehicleModal = () => {

    setShowAddVehicle(false);
    setShowEditVehicle(false);
    setViewVehicle(false);
    setShowViewLiveVehicle(false);
    setShowHistoryDetails(false);
    setShowHistoryPlayback(false);
    FillGrid(statusId);      
         
} 
const closeModal = () => 
  {
        setShowAddVehicle(false);
        setShowEditVehicle(false);
        setViewVehicle(false);
        setShowLocation(false); 
        setShowViewLiveVehicle(false);
        setShowHistoryDetails(false);
        setShowHistoryPlayback(false);         
  } 
const closeViewVehicleModal = () => {

    setShowAddVehicle(false);
    setShowEditVehicle(false);
    setViewVehicle(false);
    setShowViewLiveVehicle(false);
    setShowHistoryDetails(false);
    setShowHistoryPlayback(false);
         
}  
const closeHistoryModal=()=>
  {
        setShowEditVehicle(false);
        setViewVehicle(false);
        setShowLocation(false); 
        setShowViewLiveVehicle(false);
        setShowHistoryDetails(false);
        setShowHistoryPlayback(false);
  }
  const closeHistoryPlaybackModal=()=>
  {
            setShowEditVehicle(false);
            setViewVehicle(false);
            setShowLocation(false); 
            setShowViewLiveVehicle(false);
            setShowHistoryDetails(false);
            setShowHistoryPlayback(false);
  }
const changeVHandler = (event) => {

  if(event.target.name==='vYear' )
  {
        const re = /^[0-9\b]+$/;
        if (event.target.value === '' || re.test(event.target.value)) 
        {
             const name = event.target.name;
             //alert(name);
             const value = event.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['vYear']: ""}))
              
        }
        
  }
  else if(event.target.name==='vMileage' )
    {
          const re = /^[0-9\b]+$/;
          if (event.target.value === '' || re.test(event.target.value)) 
          {
                const name = event.target.name;
                const value = event.target.value;
                setInputs(values => ({...values, [name]: value}))
          }
          else
          {
            setInputs(values => ({...values, ['vMileage']: ""}))                
          }          
    }
  else
  {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({...values, [name]: value}))
}
  }
const changeVEHandler = (event) => {
  if(event.target.name==='vYear')
  {
        const re = /^[0-9\b]+$/;
        if (event.target.value === '' || re.test(event.target.value)) 
        {
         
              const name = event.target.name;
             //alert(name);
             const value = event.target.value;
             setInputsEdit(values => ({...values, [name]: value}))
        }
        else
        {
          setInputsEdit(values => ({...values, ['vYear']: ""}))
              
        }
        
  }
  else if(event.target.name==='vMileage')
    {
          const re = /^[0-9\b]+$/;
          if (event.target.value === '' || re.test(event.target.value)) 
          {
               const name = event.target.name;               
               const value = event.target.value;
               setInputsEdit(values => ({...values, [name]: value}))
          }
          else
          {
            setInputsEdit(values => ({...values, ['vMileage']: ""}))
                
          }          
    }
  
  else
  {
    const name = event.target.name;
    const value = event.target.value;
    setInputsEdit(values => ({...values, [name]: value}))
  }
  }
const vehicleInsert=() => {

    console.log(inputs);
   if((!inputs.vehicleNumber) || inputs.vehicleNumber==='')
    {
        toast.error("Vehicle number is required.");
       return;
    }
    else if(vCategoryID ===0)
    {
        toast.error("Vehicle type is required.");
       return;
    }    
    else if(vIEMINumber=== 0)
    {
        toast.error("Device IMEI number is required.");
       return;
    }
    else if(vCountryID===0)
    {
        toast.error("Country is required.");
       return;
    }
    else if(vStateID===0)
    {
        toast.error("State is required.");
       return;
    }    
    else
    {
           //Insert vehicle Details
           const vparams = JSON.stringify({
            "vehicleId": 0,
            "accountID": userId,            
            "imeiNumber": vIEMINumber,
            "vehicleNumber": inputs.vehicleNumber,
            "enginNumber": inputs.vEnginNumber,
            "vehicleBrand": inputs.vBrand,
            "plateNumber": inputs.plateNumber,
            "vehicleModel": inputs.vModel,
            "mileage": inputs.vMileage,
            "vin": inputs.vVin,
            "vehicleTypeID": vCategoryID,
            "driverID":vDriverID,
            "regYear": inputs.vYear,
            "imgPath": "",
            "fastTag": inputs.vFasTag,
            "countryID": vCountryID,
            "stateID": vStateID,
            "odInitialReading": inputs.vOdometerReading,
            "tankCapacity": inputsEdit.vTankCapacity        
        });
        
         //alert(API_URL+'NewInsertVehicle/');
         //alert(vparams);
        
        axios.post(API_URL+'NewInsertVehicle/', vparams, {
    
             "headers": 
             {
                    "content-type": "application/json",    
             },
    
        })
          .then(function (response) 
          {
                                 
            if(response.data.validStatus === false)
            {
                toast.error(response.data.message); 
            }
            else
            {
                toast.success(response.data.message);               
                setInputs({});   
                setVCategoryID(0);
                setVCountryID(0);
                setVStateID(0);    
                setVIEMINumber(0);
                setVDriverID(0);             
           }
          }).catch(function(error){console.log(error.message);
            
          });            
            
      }
          
}

const vehicleEdit=()=> {
    
    console.log(inputsEdit);
   if((!inputsEdit.vehicleNumber) || inputsEdit.vehicleNumber==='')
    {
        toast.error("Vehicle number is required.");
       return;
    }
    /*else if((!inputsEdit.plateNumber) || inputsEdit.plateNumber==='')
    {
        toast.error("Plate Number is Required.");
       return;
    }*/
   else if(veCategoryID ===0)
    {
        toast.error("Vehicle type is required.");
       return;
    }    
    else if(veIEMINumber===0) 
    {
        toast.error("Device IMEI number is Required.");
         return;
    }
    else if(veCountryID===0)
    {
        toast.error("Country is required.");
       return;
    }
    else if(veStateID==="0")
    {
        toast.error("State is required.");
       return;
    }    
    else
    {
     
           //Insert vehicle Details
           const vparams = JSON.stringify({
            "vehicleId": inputsEdit.vehicleId,
            "accountID": userId,            
            "imeiNumber": veIEMINumber,
            "driverID": vEDriverID,
            "vehicleNumber": inputsEdit.vehicleNumber,
            "enginNumber": inputsEdit.vEnginNumber,
            "vehicleBrand": inputsEdit.vBrand,
            "plateNumber": inputsEdit.plateNumber,
            "vehicleModel": inputsEdit.vModel,
            "vin": inputsEdit.vVin,
            "vehicleTypeID": veCategoryID,
            "regYear": inputsEdit.vYear,
            "imgPath": "",
            "fastTag": inputsEdit.vFasTag,
            "countryID": veCountryID,
            "stateID": veStateID,
            "mileage" : inputsEdit.vMileage,
            "odInitialReading": inputsEdit.vOdometerReading,
            "tankCapacity": inputsEdit.vTankCapacity      
        });
       
        
        //alert(vparams);
        //alert(API_URL+'NewInsertVehicle/');
        axios.post(API_URL+'NewInsertVehicle/', vparams, {
    
             "headers": 
             {
                    "content-type": "application/json",    
             },
    
        })
          .then(function (response) 
          {
                                 
            if(response.data.validStatus === false)
            {
                toast.error(response.data.message); 
            }
            else
            {
                toast.success(response.data.message); 
                FillGrid(0);
                //setInputs({});   
                //setVCategoryID(0);
                //setVCountryID(0);
                //setVStateID(0);  
                //setVEDriverID(0);               
           }
          }).catch(function(error){console.log(error.message);});
            
            
          /*  */  
      
        }
          
}
const showDetailsModal = (index) => {
     
    const vurls=API_URL+`VehicleListbyId/${index}`;
    //alert(vurls);
    axios.get(vurls).then(response => {    
                    
                    setSVehicleNo(response.data.data[0].vehicleNumber);                    
                    setSPlateNo(response.data.data[0].plateNumber);                             
                    setSVehicleType(response.data.data[0].vehicleType);                             
                    setSVIN(response.data.data[0].vin);   
                    setSMake(response.data.data[0].vehicleBrand);                        
                    setSModel(response.data.data[0].vehicleModel);                         
                    setSYear(response.data.data[0].regYear);                          
                    setSEngineNo(response.data.data[0].enginNumber);                           
                    setSIMEINo(response.data.data[0].imeiNumber); 
                    setSFASTag(response.data.data[0].fasTag);  
                    setSMileage(response.data.data[0].mileage);
                    setSCountry(response.data.data[0].countryName);  
                    setSState(response.data.data[0].stateName);
                    setSDriverName(response.data.data[0].driverName);
                    setSContactNumber(response.data.data[0].contactNumber);
                    setSAddress(response.data.data[0].address);   
                    setSOdometerReading(response.data.data[0].odInitialReading);                                    
                    setSTankCapacity(response.data.data[0].tankCapacity)
            }).catch(function(error){console.log(error.message);});    
       
        setViewVehicle(true);
    
}
const showEditVehicleDetails=(index) => {

    const catUrl=API_URL+"VehicleType/2";
    axios.get(catUrl).then(response => {
        setVCategoryData(response.data.data);
    }).catch(function(error){console.log(error.message);}); 
    
    axios.post(API_URL+'countries').then(response => {
           setVCountryData(response.data.data);        
        }).catch(function(error){console.log(error.message);});
        
    axios.post(API_URL+'states?Country_ID=1').then(response => {
           setVStateData(response.data.data);  
        }).catch(function(error){console.log(error.message);});
    
     //Driver List
     const ADriveUrl=API_URL+`PendingDriverList?StatusID=0&AccountID=${userId}`;
     setVDriverData([]);
      axios.get(ADriveUrl).then(response => 
      {

        if(response.data.validStatus)
        {
            
          setVDriverData(response.data.data);  
       
        }
      }).catch(function(error){console.log(error.message);});

      const IEMIUrl=API_URL+`ImeipendingList/{id}?StatusID=0&AccountID=${userId}`;
      setVIEMIData([]);
      axios.get(IEMIUrl).then(response => 
      {
        setVIEMIData(response.data.data); 
      {/*  if(response.data.validStatus)
        {
             }*/}
      }).catch(function(error){console.log(error.message);});

      /*setInputsEdit({}); setVEDriverID(0);  setVeIEMINumber(0); setVeCategoryID(0);  setVeCountryID(0);  setVeStateID(0); */
    const vurls=API_URL+`VehicleListbyId/${index}`;
    //alert(vurls);
    inputsEdit.vehicleId= index;
    axios.get(vurls).then(response => {               
    console.log("---------------------Check----------------------");
                    console.log(response.data.data);
                    inputsEdit.vehicleNumber = response.data.data[0].vehicleNumber;                    
                    inputsEdit.plateNumber = response.data.data[0].plateNumber;         
                    inputsEdit.vVin = response.data.data[0].vin;   
                    inputsEdit.vBrand = response.data.data[0].vehicleBrand;                        
                    inputsEdit.vModel = response.data.data[0].vehicleModel;                         
                    inputsEdit.vYear = response.data.data[0].regYear;                          
                    inputsEdit.vEnginNumber = response.data.data[0].enginNumber;    
                    setVEDriverID(response.data.data[0].driverID==null?0:response.data.data[0].driverID);                 
                    setVeIEMINumber(response.data.data[0].imeiNumber==null?"0":response.data.data[0].imeiNumber); 
                    inputsEdit.vFasTag = response.data.data[0].fasTag;  
                    setVeCategoryID(response.data.data[0].vehicleTypeID);
                    setVeCountryID(response.data.data[0].countryId);
                    setVeStateID(response.data.data[0].stateID);  
                    inputsEdit.vMileage = response.data.data[0].mileage; 
                    inputsEdit.vOdometerReading= response.data.data[0].odInitialReading;
                    inputsEdit.vTankCapacity= response.data.data[0].tankCapacity;
                    
                                       
            }).catch(function(error){console.log(error.message);});    
       
    setShowEditVehicle(true);
}  

const showLocationDetailsModal = (index) => 
  {
    
    const d_Id = index;                           
    const lurls=API_URL+`GetDeviceDetails/${d_Id}/`;
        
    axios.post(lurls).then(response => 
    {                  
      setFilteredLocdata(response.data.data);

    }).catch(function(error) 
    {  
      console.log(error.message); 
    });
    
    setDID(d_Id); 
    setShowLocation(true); 
    setShowAddVehicle(false);
    setShowEditVehicle(false);
    setViewVehicle(false); 
    
}

const showLiveVehiclesModal = (index) => {
     
     let webURL=websiteUrl();
     setShowViewLiveVehicle(true);
     //alert(webURL);
     let strUrl=webURL+ "Live.html?ID=" + index;
     setStrLiveUrl(strUrl);
      //strUrl=strUrl + index;
       
     /*
  const vurls=API_URL+`VehicleListbyId/${index}`;
 
  axios.get(vurls).then(response => {    
                  
                  setSVehicleNo(response.data.data[0].vehicleNumber);                    
                  setSPlateNo(response.data.data[0].plateNumber);                             
                  setSVehicleType(response.data.data[0].vehicleType);                             
                  setSVIN(response.data.data[0].vin);   
                  setSMake(response.data.data[0].vehicleBrand);                        
                  setSModel(response.data.data[0].vehicleModel);                         
                  setSYear(response.data.data[0].regYear);                          
                  setSEngineNo(response.data.data[0].enginNumber);                           
                  setSIMEINo(response.data.data[0].imeiNumber); 
                  setSFASTag(response.data.data[0].fasTag);  
                  setSMileage(response.data.data[0].mileage);
                  setSCountry(response.data.data[0].countryName);  
                  setSState(response.data.data[0].stateName);
                  setSDriverName(response.data.data[0].driverName);
                  setSContactNumber(response.data.data[0].contactNumber);
                  setSAddress(response.data.data[0].address);                                       
                  
          }).catch(function(error){console.log(error.message);});    
     
  setViewVehicle(true);
  */
  
}
const ChangeVCategoryID = (e) => {

    setVCategoryID(e.target.value);
       
}
const ChangeCountryD = (e) => {

    setVCountryID(e.target.value);
   
}
const ChangeStateD = (e) => {

  setVStateID(e.target.value);   

}
const ChangeVCategoryIDD = (e) => {

    setVeCategoryID(e.target.value);
       
}
const ChangeCountryID = (e) => {

    setVeCountryID(e.target.value);
   
}
const ChangeIMEI = (e) => {

  setVeIEMINumber(e.target.value);
 
}
const ChangeAIMEI = (e) => {

  setVIEMINumber(e.target.value);
 
}
const ChangeADriver = (e) => {

  setVDriverID(e.target.value);
 
}
const ChangeEDriver = (e) => {

  setVEDriverID(e.target.value);
 
}
const ChangeStateID = (e) => {

  setVeStateID(e.target.value);   

}
const DeleteVehicleDetails=(index)=>{

  if(window.confirm('Do you want to disable the vehicle?'))
  {
    const ddurls=API_URL+`Vehicle_Delete?AccountID=${userId}&Vehicle_ID=${index}`;
    //alert(ddurls);
    axios.post(ddurls).then(response => {
    if(response.data.validStatus === false)
           {
               toast.error(response.data.message); 
           }
           else
           {
                
               FillGrid(0);
           }        
  }).catch(function(error) 
  {
    console.log(error.message);
  }); 
} 
else 
{
        toast.error('Disable operation canceled.');
}
}

const  shareLocationClick = (IMEI_No) => 
  {

   const WEB_URL=process.env.REACT_APP_WEB;//    wEBURL();    
   
    setImeiNo(IMEI_No);
    const daurls=API_URL+`Externaltoken/${IMEI_No}/24`; 
    const response =  axios.post(daurls).then(response => 
     {
        const copyurls=WEB_URL+`Monitor.html?token=${response.data.data[0].token}`;  
        
        navigator.clipboard.writeText(copyurls)
        .then(() => 
        {
              alert("successfully copied,Please share url for 24 hours");
        })
        .catch(() => 
        {
              alert("something went wrong");
        });
    
      }).catch(function(error) 
     {
       console.log(error.message);
     });  
    /* */
}

const ActionCommandONOFF=(vIMEINO,vCommandtxt)=>

  {
    if(window.confirm('Do you want to ON/OFF the vehicle?'))
    {
      const params = JSON.stringify({"IMEINumber": vIMEINO,"Command": '',"User":userName});
      axios.post(API_URL+'ActionCommand/', params, 
      {
           "headers": 
           {
                  "content-type": "application/json",    
           },
      })
        .then(function (response) 
        {
          
          
            if(!response.data.data[0].status)
             {
                   toast.error(response.data.data[0].message);
                   return;
             }
           //  else
           //  {   
           //        FillGrid(0); 
            //       toast.success(response.data.data[0].message);                 
           //  }  

             // Check First API executed
            if(response.data.data[0].status) 
            {
              const rabbitPayload = {
                commandId: crypto.randomUUID(),
                TypeId: 0,
                deviceId: vIMEINO,
                command: vCommandtxt,
                createdAt: new Date().toISOString(),
                requestedBy: userName
            };
                axios.post(API_URL+'RabbitQAONOFF',rabbitPayload,
                {
                    headers:
                    {
                        "Content-Type": "application/json"
                    }
                }
            )
            .then(function (rabbitResponse)
            {  

                 FillGrid(0);
                toast.success(response.data.data[0].message);
            })
            .catch(function (error)
            {
                console.log(error);
                toast.error("RabbitQAONOFF API failed");
            });   
          }       

        }).catch(function (error) 
        {
                toast.error(error.message);
                console.log(error);    

        });
      } 
      else 
      {
              toast.error('Action operation canceled.');
      }

  }
  const showHistoryVehiclesModal = (par1,par2) => {
     
    //alert(par1);alert(par2);
    setShowHistoryDetails(true);    
    
    setVehicleNo(par2);
    setImeiNo(par1);    
    setHimei(par1);
    setHfromdate(today);
    setHtodate(today);  
     //let strUrl= "https://login3.avtbharat.com/Live.html?ID=" + index;
     //setStrLiveUrl(strUrl);
  

}
const showHistoryPlaybackModal= (par1,par2) => {
     
  setShowHistoryPlayback(true);    
  setVehicleNo(par2);
  setImeiNo(par1);    
  setHimei(par1);
  setHfromdate(today);
  setHtodate(today); 

}
const ShowTodayData=()=>
   {  
     
     setFrFilterDate(today);
     setToFilterDate(today);
     setHfromdate(today);
     setHtodate(today);   
    
   }
   const ShowWeeklyData=()=>
   {
     
      var Startdt=getMonday(new Date());
      setHimei(imeiNo);
      setFrFilterDate(Startdt);
      setToFilterDate(today);
      setHfromdate(Startdt);    
      setHtodate(today); 
      
   }
   const ShowMonthlyData=()=>
   {
      
      var DateFirstdayofMonth = new Date();
      var firstDay = new Date(DateFirstdayofMonth.getFullYear(), DateFirstdayofMonth.getMonth(), 1).toLocaleDateString('en-CA');
      setFrFilterDate(firstDay);
      setToFilterDate(today);
      setHimei(imeiNo);
      setHfromdate(firstDay);
      setHtodate(today);
 
      
   }
    
    const ShowSearchData=()=>
    {
      if(frFilterDate> toFilterDate)
       {
         toast.error("From date should be less than to date.");
         return;
       }
       else
       {
           setHimei(imeiNo);
           setHfromdate(frFilterDate);
           setHtodate(toFilterDate);
       }
    }
    const dfrChangeHandler= (e) => 
      {
            setFrFilterDate(e.target.value); 
            setHistoryData([]);                  
      }
      const dtoChangeHandler= (e) => 
      {
            setToFilterDate(e.target.value); 
           setHistoryData([]);           
      }
   //mindate date range start
   let minDatefr = new Date()
   minDatefr.setDate(minDatefr.getDate() - 30)
   var ddfr = minDatefr.getDate();
   var mmfr = minDatefr.getMonth() + 1; 
   var yyyyfr = minDatefr.getFullYear();

   if (ddfr < 10) {ddfr = '0' + ddfr}
   if (mmfr < 10) {mmfr = '0' + mmfr}
   minDatefr = yyyyfr + '-' + mmfr + '-' + ddfr;
   //mindate date range end
   //max date start
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
    var yyyy = today.getFullYear();

    if (dd < 10) {dd = '0' + dd}
    if (mm < 10) {mm = '0' + mm}
    today = yyyy + '-' + mm + '-' + dd;     
    //max date end
function getMonday(d) 
    {
        d = new Date(d);      
        var day =d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        return new Date(d.setDate(diff)).toLocaleDateString('en-CA');
    }

const styles = {
    headsection: {
        backgroundColor:"black", color:"white",textAlign:"center"
} }
  //if (isLoading) 
  //{
  //  return <center>< LoadingSpinner/></center> ;
  //}
  return (
    <>
      <Modal isOpen={showAddVehicle}>
            <div class="modal-header">
            <h5 className='modal-title'>Add Details</h5>
            <button type="button" class="btn-close" onClick={closeVehicleModal}></button>
            </div>
            <div class="modal-body">
            <div className='row'>
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Vehicle Details </b> </span> 
                            <div className='col-md-6 col-lg-4 form-group'>
                            Vehicle# <span style={{color:"red"}}>&nbsp;*</span>
                            <input name="vehicleNumber"  type="text" maxLength={12}  className="form-control"  value={inputs.vehicleNumber || ""}  onChange={changeVHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Plate# 
                            <input name="plateNumber"  type="text" maxLength={12}  className="form-control"  value={inputs.plateNumber || ""}  onChange={changeVHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Vehicle Type <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control" name="DVCategory" value={vCategoryID || ""}  onChange={ChangeVCategoryID}  >
                            <option value={0}>Select Vehicle Type</option>
                            {vCategoryData.map((e, key) => {
                            return <option key={key} value={e.vehicleID}>{e.vehicleType}</option>;
                            })}
                             </select> 
                            </div> 
                            <div className='col-md-6 col-lg-4 form-group'>
                            VIN 
                            <input name="vVin"  type="text"   className="form-control" value={inputs.vVin || ""}  onChange={changeVHandler}></input>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Make 
                            <input name="vBrand"  type="text"   className="form-control" value={inputs.vBrand || ""}  onChange={changeVHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Vehicle Model 
                            <input name="vModel"  type="text"   className="form-control"  value={inputs.vModel || ""}  onChange={changeVHandler}/>
                            </div>
                            
                            <div className='col-md-6 col-lg-4 form-group'>
                            Engine# 
                            <input name="vEnginNumber"  type="text"   className="form-control" value={inputs.vEnginNumber || ""}  onChange={changeVHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            IMEI# <span style={{color:"red"}}>&nbsp;*</span>                          
                            <select className="form-control" name="IEMINumber" value={vIEMINumber || ""} onChange={ChangeAIMEI}  >
                            <option value={0}>Select IMEI Number</option>
                           
                            {vIEMIData.map((e, key) => {
                                return <option key={key} value={e.imeiNumber}>{e.imeiNumber}</option>;
                            })}
                           
                            </select>
                            </div>   
                            <div className='col-md-6 col-lg-4 form-group'>
                            FASTag# 
                            <input name="vFasTag"  type="text"   className="form-control" value={inputs.vFasTag || ""}  onChange={changeVHandler}/>
                            </div>  
                            <div className='col-md-6 col-lg-4 form-group'>
                            Mileage (km/ltr) 
                            <input name="vMileage"  type="text" maxLength={2}   className="form-control" value={inputs.vMileage || ""}  onChange={changeVHandler}></input>
                            </div>
                             <div className='col-md-6 col-lg-4 form-group'>
                            Initial Odometer Reading (in km)
                            <input name="vOdometerReading"  type="text" maxLength={6}   className="form-control" value={inputs.vOdometerReading || ""}  onChange={changeVHandler}></input>
                            </div>
                             <div className='col-md-6 col-lg-4 form-group'>
                            Tank Capacity (in Litres)
                            <input name="vTankCapacity"  type="text" maxLength={3}   className="form-control" value={inputs.vTankCapacity || ""}  onChange={changeVHandler}></input>
                            </div>
                            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Registration Details </b> </span>    
                           <div className='col-md-6 col-lg-4 form-group'>
                           Country <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control" name="DCountry" value={vCountryID || ""} onChange={ChangeCountryD}  >
                            <option value={0}>Select Country</option>
                            {vCountryData.map((e, key) => {
                                return <option key={key} value={e.id}>{e.country_Name}</option>;
                            })}
                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            State <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control slct" name="DState" value={vStateID || ""} onChange={ChangeStateD} >
                            <option value={0}>Select State</option>

                                {vStateData.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.state_Name}</option>;
                                })}

                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Year 
                            <input name="vYear"  type="text" maxLength={4}   className="form-control" value={inputs.vYear || ""}  onChange={changeVHandler}></input>
                            </div>
                            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Driver Details </b> </span> 
                            <div className='col-md-6 col-lg-4 form-group'>
                            Driver#                            
                            <select className="form-control" name="vDriverID" value={vDriverID || ""} onChange={ChangeADriver}  >
                            <option value={0}>Select Driver</option>
                            {vDriverData.map((e, key) => {
                                return <option key={key} value={e.driverID}>{e.driverName}</option>;
                            })}
                            </select>
                            </div>
                           
                            
                            <div className='col-md-6 col-lg-4 form-group' style={{"paddingTop":"50px"}}>
                           </div>
                                
            </div>
            </div>
            <div class="modal-footer justify-content-center">
            <button className="btn btn-primary2" onClick={() => vehicleInsert()}>Save</button>            
             </div>  
      </Modal>
      <Modal isOpen={viewVehicle}>
            <div class="modal-header">
            <h5 className='modal-title'>View Details</h5>
            <button type="button" class="btn-close" onClick={closeVehicleModal}></button>
            </div>
            <div class="modal-body">
           
            <div className='row' >
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Vehicle Details </b> </span>    
                            <div className='col-md-6 col-lg-4 form-group'>
                         <b>Vehicle# : </b>
                            {sVehicleNo}
                           
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            <b>Plate# : </b>
                            { sPlateNo}
                            
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            <b>Vehicle Type : </b>
                            {sVehicleType} 
                            
                            </div> 
                            <div className='col-md-6 col-lg-4 form-group'>
                            <b>VIN : </b>
                            {sVIN}
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            <b>Make : </b>
                            {sMake} 
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            <b>Vehicle Model : </b>
                            {sModel} 
                            </div>
                           
                            <div className='col-md-6 col-lg-4 form-group'>
                            <b>Engine# : </b>
                           {sEngineNo}
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            <b>IMEI# : </b>
                            {sIMEINo}
                            </div>   
                            <div className='col-md-6 col-lg-4 form-group'>
                            <b>FASTag# : </b>
                            {sFASTag}
                            </div>  
                            <div className='col-md-6 col-lg-4 form-group'>
                            <b>Mileage (km/ltr) : </b>                             
                            {sMileage}
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                           <b>Odometer Reading : </b>
                            {sOdometerReading} km
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Tank Capacity : </b>
                            {sTankCapacity} litres
                           </div>
                            <span style={{"border-bottom": "1px solid #dadada", padding: "8px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Registration Details </b> </span>    
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Country : </b>
                           {sCountry}
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>State : </b>
                            {sState}                       
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                            <b>Year : </b>
                            {sYear}
                            </div>
                            
                           <span style={{"border-bottom": "1px solid #dadada", padding: "8px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Driver Details </b> </span>    
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Name : </b>
                           {sDriverName}
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Mobile : </b>
                            {sContactNumber}                       
                           </div> 
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Address : </b>
                            {sAddress}                       
                           </div>
                            <div className='col-md-6 col-lg-4 form-group' style={{"paddingTop":"50px"}}>
                           </div>
                           
            </div>
             
            </div>
          
      </Modal>
      <Modal isOpen={showEditVehicle}>
            <div class="modal-header">
            <h5 className='modal-title'>Update Details</h5>
            <button type="button" class="btn-close" onClick={closeVehicleModal}></button>
            </div>
            <div class="modal-body">
            <div className='row'>
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Vehicle Details </b> </span> 
                            <div className='col-md-6 col-lg-4 form-group'>
                            Vehicle# <span style={{color:"red"}}>&nbsp;*</span>
                            <input name="vehicleNumber"  type="text" maxLength={12}  className="form-control"  value={inputsEdit.vehicleNumber || ""}  onChange={changeVEHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Plate# 
                            <input name="plateNumber"  type="text" maxLength={12}  className="form-control"  value={inputsEdit.plateNumber || ""}  onChange={changeVEHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Vehicle Type <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control" name="DVCategory" value={veCategoryID || ""}  onChange={ChangeVCategoryIDD}  >
                            <option value={0}>Select Vehicle Type</option>
                            {vCategoryData.map((e, key) => {
                            return <option key={key} value={e.vehicleID}>{e.vehicleType}</option>;
                            })}
                             </select> 
                            </div> 
                            <div className='col-md-6 col-lg-4 form-group'>
                            VIN 
                            <input name="vVin"  type="text"   className="form-control" value={inputsEdit.vVin || ""}  onChange={changeVEHandler}></input>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Make 
                            <input name="vBrand"  type="text"   className="form-control" value={inputsEdit.vBrand || ""}  onChange={changeVEHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Vehicle Model 
                            <input name="vModel"  type="text"   className="form-control"  value={inputsEdit.vModel || ""}  onChange={changeVEHandler}/>
                            </div>
                            
                            <div className='col-md-6 col-lg-4 form-group'>
                            Engine# 
                            <input name="vEnginNumber"  type="text"   className="form-control" value={inputsEdit.vEnginNumber || ""}  onChange={changeVEHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            IMEI#<span style={{color:"red"}}>&nbsp;*</span>  
                                   
                            <select className="form-control" name="IEMINumber" value={veIEMINumber || ""} onChange={ChangeIMEI}  >
                            <option value={0}>Select IMEI Number</option> 
                            {vIEMIData.map((e, key) => 
                            {
                                return <option key={key} value={e.imeiNumber}>{e.imeiNumber}</option>;
                            })}
                            </select>
                            </div>   
                            <div className='col-md-6 col-lg-4 form-group'>
                            FASTag# 
                            <input name="vFasTag"  type="text"   className="form-control" value={inputsEdit.vFasTag || ""}  onChange={changeVEHandler}/>
                            </div>     
                            <div className='col-md-6 col-lg-4 form-group'>
                            Mileage (km/ltr) 
                            <input name="vMileage"  type="text" maxLength={2}   className="form-control" value={inputsEdit.vMileage || ""}  onChange={changeVEHandler}></input>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Odometer Reading (in km)
                            <input name="vOdometerReading"  type="text" maxLength={6}   className="form-control" value={inputsEdit.vOdometerReading || ""}  onChange={changeVEHandler}></input>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Tank Capacity (in Litres)
                            <input name="vTankCapacity"  type="text" maxLength={3}   className="form-control" value={inputsEdit.vTankCapacity || ""}  onChange={changeVEHandler}></input>
                            </div>
                            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Registration Details </b> </span> 
                           <div className='col-md-6 col-lg-4 form-group'>
                           Country <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control" name="DCountry" value={veCountryID || ""} onChange={ChangeCountryID}  >
                            <option value={0}>Select Country</option>
                            {vCountryData.map((e, key) => {
                            return <option key={key} value={e.id}>{e.country_Name}</option>;
                            })}
                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            State <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control slct" name="DState" value={veStateID || ""} onChange={ChangeStateID} >
                            <option value={0}>Select State</option>

                                {vStateData.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.state_Name}</option>;
                                })}

                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Year 
                            <input name="vYear"  type="text" maxLength={4}  className="form-control" value={inputsEdit.vYear || ""}  onChange={changeVEHandler}></input>
                            </div>
                            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Driver Details </b> </span> 
                            <div className='col-md-6 col-lg-4 form-group'>
                            Driver#                            
                            <select className="form-control" name="veDriverID" value={vEDriverID || ""} onChange={ChangeEDriver}  >
                            <option value={0}>Select Driver</option>
                            
                            {vDriverData.map((e, key) => {
                                return <option key={key} value={e.driverID}>{e.driverName}</option>;
                            })}
                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group' style={{"paddingTop":"50px"}}>
                           </div>
                                
            </div>
            </div>
            <div class="modal-footer justify-content-center">
            <button className="btn btn-primary2" onClick={() => vehicleEdit()}>Update</button>            
             </div>  
      </Modal>
      <Modal isOpen={showLocation} >
            <div class="modal-header">
                <h5 className='modal-title'>Device Location Details</h5>
                <button type="button" class="btn-close" onClick={closeModal}></button>
                </div>
                <div class="modal-body">
            
            <div class="row">
            <Ctus id= {dID}/>
          {/*  <Locations device_Id={dID}/> */}
            </div> </div>
      </Modal>
      <ModalSale isOpen={showViewLiveVehicle}>
            <div class="modal-header">
            <h5 className='modal-title'>View Live</h5>
            <button type="button" class="btn-close" onClick={closeVehicleModal}></button>
            </div>
            <div class="modal-body">
            <div className='row'>
            
            <iframe width="1000px" height="800px" src={strLiveUrl}  title="" ></iframe> 
                                
            </div>
            </div>
            
      </ModalSale>
      <ModalSale isOpen={showHistoryDetails} >
       
     <div class="modal-header">
                <h5 className='modal-title'>History Details</h5>
                <button type="button" class="btn-close" onClick={closeHistoryModal}></button>
     </div>
     <div class="modal-body" >                 
                <span style={{float: "left"}}>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="1" id="btnTodayData" onClick={ShowTodayData} >Today</button>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="2" id="btnWeeklyData" onClick={ShowWeeklyData} >Weekly</button>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnMonthlyData" onClick={ShowMonthlyData} >Monthly</button>
                </span>
                <div class="row" >
                <div class="col-sm-1 col-md-1 form-group">From:</div>
                <div class="col-sm-4 col-md-4 form-group">
                <input type="date" className="form-control"  value={frFilterDate}  placeholder="dd-mm-yyyy" onChange={dfrChangeHandler}  min={minDatefr} max={today} />
                </div>
                <div class="col-sm-1 col-md-1 form-group" >To:</div>
                <div class="col-sm-4 col-md-4 form-group">
                <input type="date" className="form-control"  value={toFilterDate}  placeholder="dd-mm-yyyy" onChange={dtoChangeHandler}  min={minDatefr} max={today} />
                </div>
                <div class="col-sm-1 col-md-1 form-group">
                <button type="button" class="btn btn-primary2 mt-20" tabindex="4" id="btnSearch" onClick={ShowSearchData} >Search</button>
                </div>
                </div>
                <div><b> Vehicle No : {vehicleNo}</b></div>
                <br /> 
                <div hidden={isShowMap}>                
                <HistoryonMap Historyobj={historyonmapinfo} /> 
                 </div>       
                
                
                </div>
    </ModalSale>
    <ModalSale isOpen={showHistoryPlayback} >
       
       <div class="modal-header">
                  <h5 className='modal-title'>History Playback Details</h5>
                  <button type="button" class="btn-close" onClick={closeHistoryPlaybackModal}></button>
       </div>
                  <div class="modal-body" >                 
                  <span style={{float: "left"}}>
                  <button type="button" class="btn btn-primary2 mt-20" tabindex="1" id="btnTodayData" onClick={ShowTodayData} >Today</button>
                  <button type="button" class="btn btn-primary2 mt-20" tabindex="2" id="btnWeeklyData" onClick={ShowWeeklyData} >Weekly</button>
                  <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnMonthlyData" onClick={ShowMonthlyData} >Monthly</button>
                  </span>
                  <div class="row" >
                  <div class="col-sm-1 col-md-1 form-group">From:</div>
                  <div class="col-sm-4 col-md-4 form-group">
                  <input type="date" className="form-control"  value={frFilterDate}  placeholder="dd-mm-yyyy" onChange={dfrChangeHandler}  min={minDatefr} max={today} />
                  </div>
                  <div class="col-sm-1 col-md-1 form-group" >To:</div>
                  <div class="col-sm-4 col-md-4 form-group">
                  <input type="date" className="form-control"  value={toFilterDate}  placeholder="dd-mm-yyyy" onChange={dtoChangeHandler}  min={minDatefr} max={today} />
                  </div>
                  <div class="col-sm-1 col-md-1 form-group">
                  <button type="button" class="btn btn-primary2 mt-20" tabindex="4" id="btnSearch" onClick={ShowSearchData} >Search</button>
                  </div>
                  </div>
                  <div><b> Vehicle No : {vehicleNo}</b></div>
                  <br /> 
                  <div hidden={isShowMap}>                
                  <HistoryPlayback Historyobj={historyonmapinfo} /> 
                   </div>       
                  
                  
                  </div>
    </ModalSale>
      <div className="top-bar clearfix">
      <div className="row">       
      <div className="col-md-4">
      <h2> Vehicles</h2></div>
      <div className="col-md-8 text-right">
      <button type="submit" id="Save" onClick={() => showAddVehicleDetails()} className="btn btn-new">New</button>
      <select onChange={exportStatus} className="btn btn-primary" name="Export"  value={statusId} >
      <option value={"0"}>All</option>    
      <option value={"1"}>Enabled</option>  
      <option value={"2"}>Disabled</option>                 
      </select> 
      <select  onChange={exportDownload}  className="btn btn-primary" name="Download" >
      <option value={"Download"}>Download</option>    
      <option value={"Excel"}>Excel</option>    
      <option value={"PDF"}>PDF</option>  
      </select>
      </div></div></div>

 {/* Filter data start  */}
    
 <div className="container-fluid p-3">
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
    <div class="row align-items-end">  
    <div class="col-sm-3 col-lg-2">Vehicle#<input type="text" class="form-control" tabindex="1" id="txtTripNumber" value={sVehicle} onChange={VchangeHandler} maxlength="50"/>
    </div>
    <div class="col-sm-3 col-lg-2">Vehicle Model<input type="text" class="form-control" tabindex="1" id="txtTripNumber" value={ssmodel} onChange={MchangeHandler} maxlength="50"/>
    </div>
    <div class="col-sm-3 col-lg-2">Driver Name<input type="text" class="form-control" tabindex="1" id="txtTripNumber" value={sdriver} onChange={DchangeHandler} maxlength="50"/>
    </div>       
      <div class="col-sm-4 col-lg-2">
      <button type="button" class="btn btn-primary2 mt-20" tabindex="6" id="btnTripAdvancedSearchNew" onClick={FilterGrid} >Search</button>
      <button type="button" class="btn btn-secondary mt-20" id="btnTripResetAdvancedSearchNew" tabindex="7" onClick={ResetTripList}>Reset
      </button></div></div>
    
  </div></div>
  {/* Filter data end  */}
      <div className="container-fluid p-3">     
      <div class="card mb-3 shadow no-border border-0">
      <div class="card-body p-0">
          <table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
            <thead>
              <tr>
                <th style={{textAlign:"center"}} width="5%">S.No.</th>
                <th width="10%" onClick={()=>sorting("vehicleNumber") } style={{textAlign:"center","cursor": "pointer"}}>Vehicle Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th> 
                <th width="10%" onClick={()=>sorting("imeiNumber") } style={{textAlign:"center","cursor": "pointer"}}>IMEI Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>                
                <th width="10%" onClick={()=>sorting("plateNumber") } style={{textAlign:"center","cursor": "pointer"}}>Plate Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>                               
                <th width="10%" onClick={()=>sorting("enginNumber") } style={{textAlign:"center","cursor": "pointer"}}>Engine Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="5%" onClick={()=>sorting("vehicleBrand") } style={{textAlign:"center","cursor": "pointer"}}>Make &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="9%" onClick={()=>sorting("vehicleModel") } style={{textAlign:"center","cursor": "pointer"}}>Vehicle Model &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("vehicleType") } style={{textAlign:"center","cursor": "pointer"}}>Vehicle Type &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("driverName") } style={{textAlign:"center","cursor": "pointer"}}>Driver Name &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>  
                
                <th width="7%" onClick={()=>sorting("status") } style={{textAlign:"center","cursor": "pointer"}}>Status &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>  
                <th onClick={()=>sorting("vehicleID") } style={{textAlign:"center"}} width="14%">Action</th>            
              </tr>
            </thead>
            <tbody>
              {currentPost.map((Val) =>
              {
              return (
              <>
              <tr key={Val.id}>
              <td style={{textAlign:"center"}}> {Val.id}</td>              
              <td>{Val.vehicleNumber}</td>
              <td>{Val.imeiNumber}</td>
              <td>{Val.plateNumber}</td>
              <td>{Val.enginNumber}</td>
              <td>{Val.vehicleBrand}</td>
              <td>{Val.vehicleModel}</td>
              <td> {Val.vehicleType}</td>
              <td>{Val.driverName}</td>   
              <td>{Val.status}
              {/*{Val.commandStatus}*/}</td> 
              <td style={{ fontSize:"16px"}}>
              <span style={{textAlign:"left"}}>
              <i title="View Live" onClick={() => showLiveVehiclesModal(Val.imeiNumber)} style={{ fontSize:"14px", color:"#4edd4e", cursor:'pointer'}} className={(Val.acc===0 || Val.status==="Disabled") ?"display:none":"display:block fa-solid fa-wifi"}></i>              
              &nbsp;&nbsp;<i title="View History" onClick={() => showHistoryVehiclesModal(Val.imeiNumber, Val.vehicleNumber)}  style={{ fontSize:"14px", color:"#4edd4e", cursor:'pointer',color: "brown"}}  class='fas fa-history' ></i>           
              &nbsp;&nbsp;<i title="History Playback" onClick={() => showHistoryPlaybackModal(Val.imeiNumber, Val.vehicleNumber)}  className="fa-solid fa-play" style={{ fontSize:"14px", color:"#f53bee", cursor:'pointer'}}></i>
              &nbsp;&nbsp;<i onClick={() => showLocationDetailsModal(Val.deviceID)} style={{ color:"orange", cursor:'pointer'}} className={Val.status==="Disabled"?"display:none":"display:block fa-solid fa-location-dot"}  title="Monitor"></i>
              &nbsp;&nbsp;<i  onClick={() => shareLocationClick(Val.imeiNumber)} style={{ color:"rgb(13, 110, 253)", cursor:'pointer'}}  className={ Val.status==="Disabled" ?"display:none":"display:block fa-solid fa-share-nodes"}  title="Share Location"></i> 
              {/* &nbsp;&nbsp;<i   onClick={() => ActionCommandONOFF(Val.imeiNumber,Val.vCommandtxt)}  style={{ color:"red",cursor:'pointer'}}   className={Val.status==="Disabled" || Val.iS_Relay===false?"display:none": (Val.commandStatus==="OFF") ?"fas fa-car":"fa fa-power-off"}  title="ON/OFF"></i>   */}
              {/* Added Nitesh on 22 09 2026  */}
               &nbsp;&nbsp;<i onClick={() => { const command = Val.commandStatus === "OFF"? "relay,1#" : "relay,0#";  ActionCommandONOFF(  Val.imeiNumber, command );}}  style={{ color: "red", cursor: "pointer" }} className={ Val.status === "Disabled" || Val.iS_Relay === false  ? "display:none" : (Val.commandStatus === "OFF") ? "fas fa-car" : "fa fa-power-off" }  title="ON/OFF"></i>        

               {/* End Nitesh on 22 09 2026 */}              
              </span>
              <span style={{paddingLeft:"20px" }} >
              <i onClick={() => showDetailsModal(Val.vehicleID)} style={{ color:"green", cursor:'pointer'}} className={ Val.status==="Disabled" ?"display:none":"display:block fa-solid fa-list"} title="View Details"></i>
              &nbsp;&nbsp;<i  onClick={() => showEditVehicleDetails(Val.vehicleID)} style={{ color:"rgb(13, 110, 253)", cursor:'pointer'}}  className={ Val.status==="Disabled" ?"display:none":"display:block fa-solid fa-pen-to-square"}  title="Update Details"></i>              
              &nbsp;&nbsp;<i onClick={() => DeleteVehicleDetails(Val.vehicleID)} style={{ color:"red", cursor:'pointer'}} className={Val.status==="Disabled"?"display:none":"display:block  fa-solid fa-trash"}  title="Disable"></i>
              </span>
              </td></tr>
              </>
              );
               })}
            </tbody>
          </table>
            <ReactPaginate  previousLabel={"<<"}  nextLabel={">>"} pageCount={PageCount}  onPageChange={ChangePage} disableInitialCallback={true}
            initialPage={0}  containerClassName={'pagination justify-content-end'} pageClassName={'page-item'}  pageLinkClassName={'page-link'}
            previousClassName={'page-item'} previousLinkClassName={'page-link'}  nextClassName={'page-item'}  nextLinkClassName={'page-link'}
            breakClassName={'page-item'}  breakLinkClassName={'page-link'}  activeClassName={'active'}></ReactPaginate>
        </div>
      </div></div></div>
      <ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
    </>
  );
};
export default CLVehicleList;


